import type {
	PathfinderRequest,
	PathfinderResult,
	PathfinderRunOptions,
	PathfinderSimulateRequest,
	PathfinderSimulateResult,
} from "@domain/Pathfinder";
import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";
import { env } from "../../config/env";

export class PathfinderAPI {
	private baseUrl = `${env.rogoApiUrl}/pathfinder`;

	public async findPath(request: PathfinderRequest, options: PathfinderRunOptions): Promise<PathfinderResult> {
		const params = { debug_geojson: options.debugGeoJson, trace: options.trace };
		const config = { ...StandardAxiosConfig(), params };
		const response = await apiClient.post<PathfinderResult>(`${this.baseUrl}/find`, request, config);
		return response.data;
	}

	public async simulate(request: PathfinderSimulateRequest): Promise<PathfinderSimulateResult> {
		const config = StandardAxiosConfig();
		const response = await apiClient.post<PathfinderSimulateResult>(`${this.baseUrl}/simulate`, request, config);
		return response.data;
	}
}
